import { de, enUS, es, fr, it, ja, ko, ru, zhCN } from 'date-fns/locale';

import deAyrade from './lang/de.json';
import enAyrade from './lang/en.json';
import esAyrade from './lang/es.json';
import frAyrade from './lang/fr.json';
import itAyrade from './lang/it.json';
import jaAyrade from './lang/ja.json';
import koAyrade from './lang/ko.json';
import ruAyrade from './lang/ru.json';
import zhAyrade from './lang/zh.json';

export type LanguageCode = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'ko' | 'ru' | 'zh';

// OAEV Supported Local Language
export const oaevLocaleMap: Record<LanguageCode, Record<string, string>> = {
  de: deAyrade,
  en: enAyrade,
  es: esAyrade,
  fr: frAyrade,
  it: itAyrade,
  ja: jaAyrade,
  ko: koAyrade,
  ru: ruAyrade,
  zh: zhAyrade,
};

// Date-fns locale map
export const dateFnsLocaleMap = {
  de,
  en: enUS,
  es,
  fr,
  it,
  ja,
  ko,
  ru,
  zh: zhCN,
};

// Moment locale map
export const momentMap: Record<LanguageCode, string> = {
  de: 'de-de',
  en: 'en-us',
  es: 'es-es',
  fr: 'fr-fr',
  it: 'it-it',
  ja: 'ja-jp',
  ko: 'ko-kr',
  ru: 'ru-ru',
  zh: 'zh-cn',
};
